<template>
    <div class="account-data">
        <div class="account-data__content">
            <header>Семейный статус</header>
            <WideMartialData
                class="account-data__block"
                v-model="profile.martial"
            />
            <header>Социальная активность</header>
            <WideSocialData
                class="account-data__block"
                v-model="profile.socialActivity"
            />
            <header>Знание языков</header>
            <WideLanguagesData
                v-model="profile.languageUserData.userLanguages"
            />
            <header>Центр компетенций</header>
            <WideCompetenceCenterData
                class="account-data__block"
                v-model="profile.competenceCenter"
            />
        </div>
        <FixedSaveBtn
            v-if="showFixedSaveBtn"
            @close="closeFixedBtn"
        >
            <ActionButton
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.fixedText"
                class="save-block__btn--position save-block__btn"
            />
        </FixedSaveBtn>
        <div
            class="save-block"
        >
            <ActionButton
                ref="otherBtn"
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.text"
                class="save-block__btn--position save-block__btn"
            />
        </div>
    </div>
</template>

<script>
import WideMartialData from './WideMartialData';
import FixedSaveBtn from '../FixedSaveBtn';
import WideSocialData from './WideSocialData';
import WideLanguagesData from './WideLanguagesData/WideLanguagesData';
import ActionButton from '../../../UI/inputs/ActionButton';
import WideCompetenceCenterData from './WideCompetenceCenterData';
import cloneDeep from 'lodash/cloneDeep';

import { mapGetters, mapActions } from 'vuex';

const getters = ['userProfileInfo'];
const actions = ['postProfileData'];

export default {
    name: 'WideOtherData',
    data: () => ({
        showFixedSaveBtn: false,
        observer: null,
        profile: {
            martial: {
                foreignMaritalStatusId: null,
                children: null,
                maidenSurname: '',
            },
            socialActivity: {
                isSocial: false,
                isVolunteer: false,
                socialActivity: '',
                volunteerActivity: '',
            },
            appendix: {
                isSecret: false,
                isMember: false,
                isCriminal: false,
                warVeteran: false,
                citizenship: '',
                foreignGosSecretTypeId: null,
                gosSecretFrom: 0,
                gosSecretTo: 0,
                isSecretNow: false,
                foreignPartyMemberId: null,
                criminal: '',
            },
            languageUserData: {
                userLanguages: [
                    {
                        foreignLanguageId: null,
                        foreignLanguageLevelId: null,
                    },
                ],
            },
            competenceCenter: {
                centerCompetitionId: null,
            },
        },
        saveButton: {
            fixedText: 'Сохранить изменения',
            text: 'Сохранить',
            color: '#4663AB',
            status: 'wait',
        },
    }),
    computed: {
        ...mapGetters(getters),
    },
    components: {
        ActionButton,
        WideMartialData,
        WideSocialData,
        WideLanguagesData,
        FixedSaveBtn,
        WideCompetenceCenterData,
    },
    created() {
        const cb = key => {
            if (this.profile.martial.hasOwnProperty(key))
                this.profile.martial[key] = this.userProfileInfo[key];
            if (this.profile.socialActivity.hasOwnProperty(key))
                this.profile.socialActivity[key] = this.userProfileInfo[key];
            if (this.profile.appendix.hasOwnProperty(key))
                this.profile.appendix[key] = this.userProfileInfo[key];
            if (this.profile.languageUserData.hasOwnProperty(key)) {
                if (Array.isArray(this.userProfileInfo[key])) {
                    this.profile.languageUserData[key] = cloneDeep(
                        this.userProfileInfo[key]
                    );
                }
            }
            if (this.profile.competenceCenter.hasOwnProperty(key))
                this.profile.competenceCenter[key] = this.userProfileInfo[key];
        };
        Object.keys(this.userProfileInfo).forEach(cb);
    },
    mounted() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach( (entry) => {
                !entry.isIntersecting && Math.sign(entry.boundingClientRect.top) === 1 ? this.showFixedSaveBtn = true : this.showFixedSaveBtn = false;
            });
        });
        this.$watch('profile', () => {
            this.observer.observe(this.$refs.otherBtn.$el);
        }, {deep: true});
    },
    beforeDestroy() {
        this.observer ? this.observer.disconnect() : '';
    },
    methods: {
        ...mapActions(actions),
        closeFixedBtn() {
            this.showFixedSaveBtn = false;
            this.observer ? this.observer.disconnect() : '';
        },
        async saveData() {
            if (this.saveButton.status != 'wait') return;
            this.saveButton.status = 'wait';
            this.saveButton.color = '#4663AB';
            this.saveButton.text = 'Сохранение...';
            this.saveButton.fixedText = 'Сохранение...';
            try {
                const sendData = {
                    ...this.profile.martial,
                    ...this.profile.socialActivity,
                    ...this.profile.appendix,
                    ...this.profile.languageUserData,
                    ...this.profile.competenceCenter,
                };
                await this.postProfileData(sendData);

                this.saveButton.status = 'wait';
                this.saveButton.color = '#238C47';
                this.saveButton.text = 'Данные сохранены';
                this.saveButton.fixedText = 'Данные сохранены';
                this.showFixedSaveBtn = false;
                this.observer ? this.observer.disconnect() : '';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            } catch (e) {
                this.saveButton.status = 'wait';
                this.saveButton.color = '#F7E9F1';
                this.saveButton.text = 'Ошибка! извините..';
                this.saveButton.fixedText = 'Ошибка! извините..';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';

.save-block {

    @include on-desktop {
        margin-top: rem(20);
    }
}
</style>
